import { Component, input, signal } from '@angular/core';
import { IonImg, IonIcon, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'ui-image-skeleton',
  standalone: true,
  imports: [IonImg, IonIcon, IonSkeletonText],
  template: `
    <div class="image-holder" [style.aspect-ratio]="ratio()">
      @if (!loaded() && !error()) {
      <ion-skeleton-text class="img-skeleton" [animated]="true" />
      }

      <ion-img
        [src]="src() ?? ''"
        [alt]="alt() ?? 'image'"
        loading="lazy"
        (ionImgWillLoad)="onWillLoad()"
        (ionImgDidLoad)="onDidLoad()"
        (ionError)="onError()"
        [class.visible]="loaded()"
      ></ion-img>

      @if (error()) {
      <div class="img-fallback">
        <ion-icon name="image-outline"></ion-icon>
      </div>
      }
    </div>
  `,
  styles: [
    `
      .image-holder {
        position: relative;
        width: 100%;
        overflow: hidden;
        aspect-ratio: 16 / 9;
        background: var(--ion-color-step-100);
      }

      ion-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      ion-img.visible {
        opacity: 1;
      }

      .img-skeleton {
        position: absolute;
        inset: 0;
        border-radius: 12px;
      }

      .img-fallback {
        position: absolute;
        inset: 0;
        display: grid;
        place-items: center;
        color: var(--ion-color-step-600);
        font-size: 28px;
      }
    `
  ]
})
export class UiImageSkeletonComponent {
  src = input<string | null>();
  alt = input<string | null>('image');
  ratio = input<string>('16 / 9');

  loaded = signal(false);
  error = signal(false);

  onWillLoad() {
    this.loaded.set(false);
    this.error.set(false);
  }
  onDidLoad() {
    this.loaded.set(true);
  }
  onError() {
    this.error.set(true);
    this.loaded.set(true);
  }
}
